import PagePopup from './PagePopup.view';

export default PagePopup;
